import { useEffect } from "react";
import { format } from 'date-fns';
import { FaChevronLeft } from "react-icons/fa";
import { Button, Table } from "react-bootstrap";
import { UAParser } from 'ua-parser-js';
import LOGO_IMG from '../../client/assets/claro.png';

import useCountdown from "../../hooks/useCountDown";
import "./index.scss";
import useDeviceManager from "../../hooks/useDeviceManager.js";

const mapStateToProps = (state) => {
    // Parse Search Params
    const searchParams = new URLSearchParams(state);
    const cp = searchParams.get('cp');
    const customerId = searchParams.get('customerId');
    const return_url = searchParams.get('return_url');
    const cancel_url = searchParams.get('cancel_url');
    const limit = searchParams.get('limit');
    const actual = searchParams.get('actual');
    const expiration = searchParams.get('expiration');

    return {
        cp,
        customerId,
        return_url,
        cancel_url,
        limit: parseInt(limit),
        actual: actual ? actual : 0,
        expiration,
        redirectToCancel: () => {
            window.location.href = cancel_url !== "undefined" ? cancel_url : return_url;
        },
    };
};

function DeviceLimitPage() {
    const props = mapStateToProps(window.location.search);

    const { minutes, seconds } = useCountdown(props.expiration);
    const { devices, loading, quantityToRemove, markDevice, markAllDevices, selectedDevices } = useDeviceManager(props.customerId, props.cp, props.return_url, props.limit);

    useEffect(() => {
        if (props.expiration && props.expiration !== 'undefined' && props.expiration !== null) {
            const expirationDate = new Date(props.expiration).getTime();
            const now = new Date().getTime();
            if (expirationDate <= now) {
                props.redirectToCancel();
            }
            console.log({ expirationDate: new Date(props.expiration), now: new Date() })
        }
    }, [minutes, seconds, loading, props.expiration, props.redirectToCancel]);

    const amountToSelect = () => {
        if (quantityToRemove - selectedDevices.length < 0) {
            return 0;
        }
        return quantityToRemove - selectedDevices.length;
    }

    const renderIcon = (device, index) => {
        return (
            <input
                key={index}
                type="checkbox"
                checked={selectedDevices.find(selectedDevice => selectedDevice.token === device.token)}
                onChange={() => !device.loading && markDevice(device)}
            />
        );
    };

    return (
        <div className="DeviceLimitPage">
         <div className='ligamax-logo'>
          <img src={LOGO_IMG} alt='logoliga' id='ligamaxlogo' />
        </div> 
            <div className="DeviceLimitPage__wrapper">
                <div className="devices">
                    <div className="header">
                        <div className='DeviceLimitPage__button-back-container'>
                            <Button className='button-back' onClick={() => props.redirectToCancel()}>
                                <FaChevronLeft />
                            </Button>
                        </div>
                        <h1>
                            {`Se ha superado el límite de ${props.limit} dispositivos activo/s`}.
                        </h1>
                        <h2>
                            {`Tienes ${minutes}:${seconds} minutos para seleccionar ${amountToSelect()} dispositivo(s) a eliminar y poder continuar`}
                        </h2>
                    </div>
                    <div className="devices-table">
                        <Table flex responsive>
                            <thead>
                                <tr>
                                    <th>
                                        Dispositivos en uso
                                    </th>
                                    <th>
                                        Fecha de creado
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {devices && devices.length > 0 &&
                                    devices.map((device, index) => {
                                        const uat = new UAParser(device.description);
                                        const description = uat.getBrowser().name ? `${uat.getBrowser().name} ${uat.getBrowser().version}` : uat.getUA();
                                        return (
                                            <tr key={device.token}>
                                                <td>{description}</td>
                                                <td>{format(new Date(device.createdAt), 'dd/MM/yyyy HH:mm')}</td>
                                                <td>
                                                    {renderIcon(device, index)}
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </Table>
                        {devices && devices.length > 0 && devices.map((device, index) => (
                        <div className="device-card" key={device.token}>
                            <div className="device-detail"><strong>Dispositivo:</strong> {device.description}</div>
                            <div className="device-detail"><strong>Fecha:</strong> {format(new Date(device.createdAt), 'dd/MM/yyyy HH:mm')}</div>
                            <div className="device-detail-delete">
                                {renderIcon(device, index)}
                            </div>
                        </div>
                    ))}
                    </div>
                    <div className="delete-all">
                        <div className="actions">
                            <Button variant="primary"
                                disabled={loading}
                                onClick={markAllDevices}>
                                    Eliminar todos
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeviceLimitPage;
